import HttpBase from './HttpClient';
import AuthBase from './AuthManager';
import JwtBase from './helpers/Jwt';
import EventDispatcher from './EventDispatcher';

const Http = new HttpBase();
const Auth = new AuthBase();
const Jwt = new JwtBase();
const Event = new EventDispatcher();

const baseUrl = process.env.REACT_APP_API_SERVER;
const bonjourUrl = process.env.REACT_APP_BONJOUR_SERVER;

Http.setBaseUrl(baseUrl);

const getDomainName = (hostName) => {
    return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
}

Http.onRequest((config) => {
    const pattern = new RegExp('^(http|https)://');
    const domain = getDomainName(baseUrl);

    if(!pattern.test(config.url) || config.url.indexOf(domain) !== -1) {
      if (config.baseUrl === bonjourUrl || config.url.indexOf(bonjourUrl) !== -1) {
        // 10 minutes
        config.timeout = 60000 * 10;
      }

      if (Auth.isAuthenticated()) {
        const { token, empresa, cliente, user } = Auth.getData();

        config.headers['X-Client-Idx'] = cliente && !!cliente.id ? cliente.id : '';
        config.headers['X-Company-Idx'] = empresa && !!empresa.id ? empresa.id : '';

        if (!!user && user.live !== undefined && config.headers['X-Tenancy'] === undefined) {
          config.headers['X-Tenancy'] = !!user.live ? 'fa/live' : 'fa/test';
        } else if (config.headers['X-Tenancy'] === undefined) {
          config.headers['X-Tenancy'] = !!empresa && !!empresa.live ? 'fa/live' : 'fa/test';
        }

        if (!!token) {
          config.headers.Authorization = 'Bearer ' + token.access_token;
        }
      } else {
        if (config.headers['X-Tenancy'] === undefined) {
          config.headers['X-Tenancy'] = 'fa/live';
        }
      }
    }

    return config;
}, (error) => Promise.reject(error));

Http.onResponse((response) => {
  if (response.request.responseType === 'blob') {
    return Promise.resolve(response);
  }

  return Promise.resolve(response.data);
}, (error) => {
  let response = error.response || {};

  if (!response.data) {
    let message = error.status ? `{error.status}  {error.statusText}` : null;
    message = message || error.message;

    response.data = {
      message: message || 'No se tiene información del error'
    }
  }

  Event.dispatch('http.error', error);

  return Promise.reject(response);
});

export {
  Http,
  Auth,
  Jwt,
  Event
}